import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Image from "mui-image";
import redbull from "../../../assets/rebbullg.svg";
import sony from "../../../assets/hm-sonyg-logo.svg";
import hilton from "../../../assets/hiltong.svg";
import boyscoutg from "../../../assets/boyscoutg.svg";
import gpg from "../../../assets/gpg.svg";
import bitmapg from "../../../assets/bitmapg.svg";
import zeplncg from "../../../assets/zeplncg.svg";
import trygg from "../../../assets/trygg.svg";
import fihg from "../../../assets/fihg.svg";
import cameo from "../../../assets/c-cameo-logo.svg";
import renesas from "../../../assets/renesas-logo.svg";
import margaritaville from "../../../assets/margaritaville-logo.svg";
import bank from "../../../assets/bank-of-america-logo.svg";
import mitsubishi from "../../../assets/mitsubishi-logo.svg";
import fujifilm from "../../../assets/fujifilm-logo.svg";
import fujifilm2 from "../../../assets/fujifilm-logo.svg";
import Link from "@mui/material/Link";

const Brand = () => {
  return (
    <section id="brands" style={{ backgroundColor: "#f7f4f4d9" }}>
      <Container
        maxWidth="lg"
        sx={{ padding: { xs: "40px 0", sm: "40px 0", md: "130px 0" } }}
      >
        <Box sx={{ flexGrow: 0 }}>
          <Grid container spacing={3} sx={{ alignItems: "center" }}>
            <Grid item xs={12} md={4}>
              <Typography
                variant="h3"
                gutterBottom
                sx={{ textAlign: { xs: "center", sm: "center", md: "left" } }}
              >
                Trusted by the world’s leading{" "}
                <span className="highlight-head">brands</span>
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={redbull} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={sony} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={hilton} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none"></Link>
                  <Image src={boyscoutg} width="80%" height={"auto"} />
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={gpg} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={bitmapg} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={zeplncg} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={trygg} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={fihg} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={cameo} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={renesas} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderBottom: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={margaritaville} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={bank} width="80%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={mitsubishi} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    borderRight: "1px solid rgb(218, 227, 246)",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={fujifilm} width="100%" height={"auto"} />
                  </Link>
                </Grid>
                <Grid
                  item
                  xs={6}
                  sm={3}
                  sx={{
                    width: "25%",
                    height: "176px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Link href="#" underline="none">
                    <Image src={fujifilm2} width="100%" height={"auto"} />
                  </Link>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Container>
    </section>
  );
};

export default Brand;
